import React from 'react';
import { Check, ArrowRight } from 'lucide-react';

import LinkButton from './LinkButton';
import css from './ValueProps.module.css';

const OWNER_POINTS = [
  <><b>Real bids in hours</b>, not three weeks of quote chasing.</>,
  <>Providers matched by ability, with a <b>verified two-way review system</b>.</>,
  <><b>Built-in contracts</b> and payment flow, Stripe-backed.</>,
  <><b>Rate & review</b> so your next RFP is even faster.</>,
];

const PROVIDER_POINTS = [
  <><b>Matched leads</b> by city, date, and your booking minimum.</>,
  <><b>No monthly fee</b>. You pay a flat 10% only when you win.</>,
  <><b>One-click bidding</b> with saved packages and templates.</>,
  <><b>Stripe payouts</b> released to your account after every completed event.</>,
];

const Column = ({ variant, chip, title, lede, points, children }) => (
  <div className={variant === 'owner' ? css.colOwner : css.colProvider}>
    <span className={css.chip}>{chip}</span>
    <h3 className={css.colTitle}>{title}</h3>
    <p className={css.colLede}>{lede}</p>
    <ul className={css.points}>
      {points.map((point, i) => (
        <li key={i} className={css.point}>
          <span className={css.check}>
            <Check />
          </span>
          <span>{point}</span>
        </li>
      ))}
    </ul>
    {children}
  </div>
);

const ValueProps = () => {
  return (
    <section className={css.section} id="value">
      <div className={css.container}>
        <div className={css.head}>
          <span className={css.overline}>Built for both sides</span>
          <h2 className={css.title}>One marketplace. Two very different wins.</h2>
        </div>

        <div className={css.grid}>
          <Column
            variant="owner"
            chip="For Hiring Companies"
            title="Fill the booth line-up, without the inbox sprawl."
            lede="Post once and let the right providers come to you, with pricing, availability, and references in one place."
            points={OWNER_POINTS}
          >
            <LinkButton name="NewListingPage" variant="primary">
              Post an event
              <ArrowRight />
            </LinkButton>
          </Column>

          <Column
            variant="provider"
            chip="For Providers"
            title="Fill your calendar with gigs that actually match."
            lede="See live RFPs inside your service area. Bid in 60 seconds. Get paid within 24 hours of the last guest leaving."
            points={PROVIDER_POINTS}
          >
            <LinkButton name="SignupPage" variant="secondary">
              Join as a Provider
              <ArrowRight />
            </LinkButton>
          </Column>
        </div>
      </div>
    </section>
  );
};

export default ValueProps;
